module.exports = __webpack_public_path__ + "static/media/2010.8cc223eb.csv";